import mobileDeviceCheck from '../../core/utils/mobile-device-check';
import getScrollbarWidth from '../../core/utils/get-scrollbar-width';
import debounce from '../../core/utils/debounce';

const InitDeviceCheck = () => {
  const root = document.documentElement;
  const scrollbarWidth = getScrollbarWidth();

  root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

  const widthCallback = isMobileWidth => root.toggleAttribute('data-mobile-width', isMobileWidth);
  const deviceCallback = isMobileDevice => root.toggleAttribute('data-mobile-device', isMobileDevice);

  mobileDeviceCheck(widthCallback, deviceCallback);

  window.addEventListener('resize', debounce(() => mobileDeviceCheck(widthCallback, deviceCallback), 100));

  return () => mobileDeviceCheck(widthCallback, deviceCallback);
};

export default InitDeviceCheck;